<user-account-form [userName]="userName">

</user-account-form>